import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';
import { Row, Col, FormGroup, Label, Card, CardBody, CardText } from 'reactstrap';
import TextArrayField from '../../TextArrayField/TextArrayField';

const BrevoFields = () => {
    const { t }                  = useTranslation();
    const { isMobile, isTablet } = useSelector(state => state.ui);

    return (
        <div className="BrevoFields">
            <Row>
                <Col>
                    <Card>
                    { ['newsletter', 'survey'].map(key => (
                        <CardBody key={key}>
                            <h5 className="IntegrationConfig-blockTitle">
                                { t(`settings.integrations.brevo.${key}`) }
                            </h5>
                            <CardText tag="div">
                                <Row>
                                    <Col>
                                        <FormGroup row>
                                        <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.brevo.api_key")}</Label>
                                            <Col lg={10} >
                                                <Field required component="input" className="form-control" type="text" name={`integrations.brevo.${key}.api_key`} id="api_key" />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.brevo.tags")}</Label>
                                            <Col lg={10} >
                                                <TextArrayField name={`integrations.brevo.${key}.tags`} id="tag" addTag={(v) => console.log(v)} />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.brevo.list_id")}</Label>
                                            <Col lg={10} >
                                                <Field required component="input" className="form-control" type="text" name={`integrations.brevo.${key}.list_id`} id="list_id" />
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardText>

                            <h6 className="IntegrationConfig-blockSubtitle">{ t('settings.integrations.brevo.attributes.title') }</h6>
                            <CardText tag="div">
                                <Row>
                                    <Col>
                                        <FormGroup row>
                                        <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.brevo.attributes.city")}</Label>
                                            <Col lg={10} >
                                                <Field required component="input" className="form-control" type="text" name={`integrations.brevo.${key}.attributes.city`} id="city" />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.brevo.attributes.address")}</Label>
                                            <Col lg={10} >
                                                <Field required component="input" className="form-control" type="text" name={`integrations.brevo.${key}.attributes.address`} id="address" />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                        <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.brevo.attributes.country")}</Label>
                                            <Col lg={10} >
                                                <Field required component="input" className="form-control" type="text" name={`integrations.brevo.${key}.attributes.country`} id="country" />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.brevo.attributes.zip")}</Label>
                                            <Col lg={10} >
                                                <Field required component="input" className="form-control" type="text" name={`integrations.brevo.${key}.attributes.zip`} id="zip" />
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardText>
                        </CardBody>
                    ))}
                    </Card>
                </Col>
            </Row>
        </div>
    );
}

export default BrevoFields;
